import { getApi, putApi, postApi, deleteApi } from "./apiBase";
import {
  data_dictionary_entities,
  data_dictionary_fields,
  data_dictionary_search,
  data_dictionary_field,
  data_dictionary_field_description,
  data_dictionary_field_verify,
  data_dictionary_gaps,
  data_dictionary_quarantine,
  data_dictionary_by_route,
  data_dictionary_regenerate,
  data_dictionary_field_draft,
  data_dictionary_draft_gaps,
  data_dictionary_refresh_facts,
  data_dictionary_facts,
  data_dictionary_relationships,
  data_dictionary_graph,
  data_dictionary_join_path,
  data_dictionary_tables,
  data_dictionary_build_query,
  data_dictionary_agent_conversations,
  data_dictionary_agent_chat,
} from "./apiURL";

export const getEntities = () => getApi(data_dictionary_entities);

export const getEntityFields = (entity) =>
  getApi(`${data_dictionary_entities}/${encodeURIComponent(entity)}/fields`);

export const searchFields = (search, take = 200, includeUnused = false) =>
  getApi(
    `${data_dictionary_fields}?search=${encodeURIComponent(search || "")}&take=${take}&includeUnused=${includeUnused}`,
  );

export const searchDictionary = (search, take = 100, includeUnused = false) =>
  getApi(
    `${data_dictionary_search}?search=${encodeURIComponent(search || "")}&take=${take}&includeUnused=${includeUnused}`,
  );

export const getField = (columnKey) =>
  getApi(`${data_dictionary_field}?columnKey=${encodeURIComponent(columnKey)}`);

export const updateFieldDescription = (columnKey, body) =>
  putApi(
    `${data_dictionary_field_description}?columnKey=${encodeURIComponent(columnKey)}`,
    body,
  );

export const verifyField = (columnKey) =>
  postApi(
    `${data_dictionary_field_verify}?columnKey=${encodeURIComponent(columnKey)}`,
    {},
  );

export const getGaps = (take = 500) =>
  getApi(`${data_dictionary_gaps}?take=${take}`);

export const getQuarantine = (take = 500) =>
  getApi(`${data_dictionary_quarantine}?take=${take}`);

export const getFieldsByRoute = (route) =>
  getApi(`${data_dictionary_by_route}?route=${encodeURIComponent(route)}`);

export const regenerateUsage = () => postApi(data_dictionary_regenerate, {});

export const draftFieldDescription = (columnKey) =>
  postApi(
    `${data_dictionary_field_draft}?columnKey=${encodeURIComponent(columnKey)}`,
    {},
  );

export const draftGaps = (take = 50) =>
  postApi(`${data_dictionary_draft_gaps}?take=${take}`, {});

export const refreshFacts = () => postApi(data_dictionary_refresh_facts, {});

// Full ColumnFacts export — the facts.json the offline extractors consume
// (Tools/DataDictionary/extract_usage.py --facts).
export const getFacts = () => getApi(data_dictionary_facts);

export const getRelationships = (table) =>
  getApi(`${data_dictionary_relationships}?table=${encodeURIComponent(table)}`);

export const getSchemaGraph = ({
  level = "table",
  focus = "",
  depth = 0,
  minConfidence = 0,
} = {}) =>
  getApi(
    `${data_dictionary_graph}?level=${encodeURIComponent(level)}&focus=${encodeURIComponent(focus || "")}&depth=${depth}&minConfidence=${minConfidence}`,
  );

export const getJoinPath = (from, to, maxHops = 4, minConfidence = 0) =>
  getApi(
    `${data_dictionary_join_path}?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}&maxHops=${maxHops}&minConfidence=${minConfidence}`,
  );

export const getRelationshipTables = () => getApi(data_dictionary_tables);

export const buildQuery = (
  columnKeys,
  includeDecodes = true,
  minConfidence = 0,
) =>
  getApi(
    `${data_dictionary_build_query}?columns=${encodeURIComponent((columnKeys || []).join(","))}&includeDecodes=${includeDecodes}&minConfidence=${minConfidence}`,
  );

export const getAgentConversations = () =>
  getApi(data_dictionary_agent_conversations);

export const getAgentConversation = (id) =>
  getApi(`${data_dictionary_agent_conversations}/${id}`);

export const postAgentChat = (conversationId, message) =>
  postApi(data_dictionary_agent_chat, { conversationId, message });

export const deleteAgentConversation = (id) =>
  deleteApi(`${data_dictionary_agent_conversations}/${id}`);
